import { IState } from '../store';
import { pathOr } from 'ramda';

export function getVillageId(state: IState): number | null {
  return pathOr(null, ['offerData', 'offer', 'kp', 'id'], state);
}
